import { Alert, AlertVariant } from '@hourly-hds/components';
import { useState } from 'react';
import styles from './Errors.module.css';

interface ErrorsProps {
  errors: Array<{ title: string; message: string }>;
}

const Errors = ({ errors }: ErrorsProps) => {
  const [errorIndex, setErrorIndex] = useState<number>(0);

  const handleClickPreviousError = () => {
    setErrorIndex((currentIndex) => (currentIndex - 1 + errors.length) % errors.length);
  };

  const handleClickNextError = () => {
    setErrorIndex((currentIndex) => (currentIndex + 1) % errors.length);
  };

  if (!errors.length) {
    return null;
  }

  const displayableError = errors[errorIndex];

  return (
    <div className={styles.container}>
      <Alert variant={AlertVariant.Error}>
        <Alert.Header>{displayableError.title}</Alert.Header>
        <Alert.Actions>
          {errors.length > 1 && (
            <Alert.Scroll onPrevious={handleClickPreviousError} onNext={handleClickNextError} />
          )}
        </Alert.Actions>

        <Alert.Divider />
        <Alert.Body>{displayableError.message}</Alert.Body>
      </Alert>
    </div>
  );
};

export default Errors;
